<h2 mat-dialog-title>{{'header.configure' | translate}}
    <mat-icon
        class="configure__head-help-icon"
        style="cursor: pointer;"
        (click)="createTplModal(tplHelpTitle, tplHelpContent, tplHelpFooter)">
        help_outline
    </mat-icon>
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onCloseDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
    <ng-template #tplHelpTitle>
        <span>{{'service_type.help_configure.modal_title' | translate}}</span>
      </ng-template>
      <ng-template #tplHelpContent>
        <!-- <p><b>{{'service_type.help_configure.modal_content3' | translate}}</b>
          {{'service_type.help_configure.modal_content4' | translate}}
        </p> -->
        <p><b>{{'service_type.help_configure.modal_content5' | translate}}</b>
          {{'service_type.help_configure.modal_content6' | translate}}
        </p>
        <p><b>{{'service_type.help_configure.modal_content7' | translate}}</b>
          {{'service_type.help_configure.modal_content8' | translate}}
        </p>
        <p><b>{{'service_type.help_configure.modal_content9' | translate}}</b>
          {{'service_type.help_configure.modal_content10' | translate}}
        </p>

        <!-- <p><b>{{'service_type.help_configure.modal_content15' | translate}}</b>
        {{'service_type.help_configure.modal_content16' | translate}}
        <span style="color: red;">{{'service_type.help_configure.modal_content_only_mobile' | translate}}</span>
        </p>
        <p><b>{{'service_type.help_configure.modal_content17' | translate}}</b>
        {{'service_type.help_configure.modal_content18' | translate}}
        <span style="color: red;">{{'service_type.help_configure.modal_content_only_mobile' | translate}}</span>
        </p> -->

        <p><b>{{'service_type.help_configure.modal_content1' | translate}}</b>
          {{'service_type.help_configure.modal_content2' | translate}}
        </p>

        <p><b>{{'service_type.help_configure.modal_content11' | translate}}</b>
          {{'service_type.help_configure.modal_content12' | translate}}
        </p>
        <p><b>{{'service_type.help_configure.modal_content13' | translate}}</b>
          {{'service_type.help_configure.modal_content14' | translate}}
        </p>
      </ng-template>
      <ng-template #tplHelpFooter>
        <button nz-button (click)="destroyTplModal()" class="v2-color-deny">
          {{'button.close' | translate}}
        </button>
      </ng-template>
  </h2>
  <div class="content">
    <mat-expansion-panel expanded="true" class="mb-3 mt-3" disabled>
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title" style="color: #444444;">
            {{'header.check' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-group d-flex">
                <div class="group-checkbox">
                    <label class="checkbox-label" for="check_num_document">
                        {{'search_form.service_type_checkCertNumber' | translate}}
                    </label>
                    <button id="check_num_document"
                        mat-icon-button class="v2-color-deny"
                        (click)="onAllowCheckSign(serviceType, serviceType.checkCertNumber, 'checkCertNumber')"
                        matTooltip="{{ serviceType.checkCertNumber ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                        ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}"
                    >
                        <mat-icon *ngIf="serviceType.checkCertNumber" class="mat-primary">check_box</mat-icon>
                        <mat-icon *ngIf="serviceType.checkCertNumber === false" class="mat-primary">check_box_outline_blank</mat-icon>
                    </button>
                </div>
                <div class="group-checkbox">
                    <label class="checkbox-label" for="check_name">
                        {{'search_form.service_type_checkName' | translate}}
                    </label>
                    <button id="check_name"
                    mat-icon-button class="v2-color-deny"
                    (click)="onAllowCheckSign(serviceType, serviceType.checkName, 'checkName')"
                    matTooltip="{{ serviceType.checkName ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                    ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}">
                        <mat-icon *ngIf="serviceType.checkName" class="mat-primary">check_box</mat-icon>
                        <mat-icon *ngIf="serviceType.checkName === false" class="mat-primary">check_box_outline_blank</mat-icon>
                    </button>
                </div>
                <div class="group-checkbox">
                    <label class="checkbox-label" for="check_otp">
                        {{'search_form.service_type_checkOtp' | translate}}
                    </label>
                    <button id="check_otp"
                    mat-icon-button class="v2-color-deny"
                    (click)="onAllowCheckSign(serviceType, serviceType.checkOtp, 'checkOtp')"
                    matTooltip="{{ serviceType.checkOtp ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                    ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}">
                        <mat-icon *ngIf="serviceType.checkOtp" class="mat-primary">check_box</mat-icon>
                        <mat-icon *ngIf="serviceType.checkOtp === false" class="mat-primary">check_box_outline_blank</mat-icon>
                    </button>
                </div>
        </div>
    </mat-expansion-panel>
    <mat-expansion-panel expanded="true" class="mb-3 mt-3" disabled>
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title" style="color: #444444;">
            {{'header.signing_method' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-group">
            <table class="mat-table">
                <tr class="mat-header-row">
                    <th class="mat-header-cell">{{'header.signing_method' | translate}}</th>
                    <th class="mat-header-cell" style="width: 70px;"></th>
                    <th class="mat-header-cell">{{'search_form.service_type_supportEKYC' | translate}}</th>
                </tr>
                <tr class="mat-row">
                    <td class="mat-cell">{{'search_form.service_type_allowOtp' | translate}}</td>
                    <td class="mat-cell">
                        <button id="sign-otp"
                                style="margin: 0 15px;"
                                mat-icon-button class="v2-color-deny"
                                (click)="onAllowCheckSign(serviceType, serviceType.allowOtp, 'allowOtp')"
                                matTooltip="{{ serviceType.allowOtp ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                                ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}">
                                    <mat-icon *ngIf="serviceType.allowOtp" class="mat-primary">check_box</mat-icon>
                                    <mat-icon *ngIf="serviceType.allowOtp === false" class="mat-primary">check_box_outline_blank</mat-icon>
                                </button>
                    </td>
                    <td class="mat-cell" rowspan="2">
                        <div class="d-flex">
                            <div class="group-checkbox">
                                <button id="sign-ekyc"
                                [disabled]="isDisableEkyc || (!serviceType.allowOtp && !serviceType.allowImage)"
                                mat-icon-button class="v2-color-deny"
                                (click)="onAllowCheckSign(serviceType, serviceType.ekycSupportConfig === 1, 'supportEkyc')"
                                matTooltip="{{ serviceType.ekycSupportConfig === 1 ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                                ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}">
                                    <mat-icon *ngIf="serviceType.ekycSupportConfig === 1 && !isDisableEkyc" class="mat-primary">radio_button_checked</mat-icon>
                                    <mat-icon *ngIf="serviceType.ekycSupportConfig !== 1 && !isDisableEkyc" class="mat-primary">radio_button_unchecked</mat-icon>
                                    <mat-icon *ngIf="isDisableEkyc" class="color-gray">radio_button_unchecked</mat-icon>
                                    <!-- <mat-icon *ngIf="isCheckSignEkyc">check_box</mat-icon>
                                    <mat-icon *ngIf="!isCheckSignEkyc">check_box_outline_blank</mat-icon> -->
                                </button>
                                <label class="checkbox-label" style="font-weight: 500;" for="sign-ekyc"
                                    [class.color-gray]="isDisableEkyc">
                                    {{'search_form.service_type_EKYC' | translate}}
                                </label>
                            </div>

                            <div class="group-checkbox">
                                <button id="sign-advanced-ekyc"
                                [disabled]="isDisableEkycAdvanced || (!serviceType.allowOtp && !serviceType.allowImage)"
                                mat-icon-button class="v2-color-deny"
                                (click)="onAllowCheckSign(serviceType, serviceType.ekycSupportConfig === 2, 'supportEkycAdvanced')"
                                matTooltip="{{ serviceType.ekycSupportConfig === 2 ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                                ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}">
                                    <mat-icon *ngIf="serviceType.ekycSupportConfig === 2 && !isDisableEkycAdvanced" class="mat-primary">radio_button_checked</mat-icon>
                                    <mat-icon *ngIf="serviceType.ekycSupportConfig !== 2 && !isDisableEkycAdvanced" class="mat-primary">radio_button_unchecked</mat-icon>
                                    <mat-icon *ngIf="isDisableEkycAdvanced" class="color-gray">radio_button_unchecked</mat-icon>
                                    <!-- <mat-icon *ngIf="isCheckSignEkycAdvanced">check_box</mat-icon>
                                    <mat-icon *ngIf="!isCheckSignEkycAdvanced">check_box_outline_blank</mat-icon> -->
                                </button>
                                <label class="checkbox-label" style="font-weight: 500;" for="sign-advanced-ekyc"
                                    [class.color-gray]="isDisableEkycAdvanced">
                                    {{'search_form.service_type_EkycAdvanced' | translate}}
                                </label>
                            </div>
                        </div>
                    </td>
                </tr>
                <!-- <tr class="mat-row">
                    <td class="mat-cell">{{'search_form.service_type_allowImage' | translate}}</td>
                    <td class="mat-cell">
                        <button id="sign-image"
                        style="margin: 0 15px;"
                                mat-icon-button class="v2-color-deny"
                                (click)="onAllowCheckSign(serviceType, serviceType.allowImage, 'allowImage')"
                                matTooltip="{{ serviceType.allowImage ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                                ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}">
                                    <mat-icon *ngIf="serviceType.allowImage" class="mat-primary">check_box</mat-icon>
                                    <mat-icon *ngIf="serviceType.allowImage === false" class="mat-primary">check_box_outline_blank</mat-icon>
                                </button>
                    </td>
                </tr> -->
            </table>
        </div>
    </mat-expansion-panel>
  </div>

